module.exports = __webpack_public_path__ + "img/lucrecia-silva-dias.a84ac947.jpg";